import React, { useEffect } from 'react'
import { ViewersExpandableChart } from '../../../../components/charts'
import { ViewersExpandableSectionProps } from './ViewersExpandableSection.types'
import { STATISTICS_PAGE_STORE, STATISTICS_VIEWER_STORE } from '../../../../store'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'

const ViewersExpandableSectionComponent = (props: ViewersExpandableSectionProps) => {
  const {
    className,
    style,
    initialIsExpandedState,
    [STATISTICS_VIEWER_STORE]: {
      chartHeaderProps,
      getViewersChartStats,
      viewerTotalStats
    },
    [STATISTICS_PAGE_STORE]: {
      selectedStoreIds
    }
  } = props

  useEffect(getViewersChartStats, [selectedStoreIds])

  return (
    <ViewersExpandableChart
      className={className}
      style={style}
      chartHeaderProps={chartHeaderProps}
      initialChartVisibility={initialIsExpandedState}
      chartData={viewerTotalStats}
    />
  )
}

const ViewersExpandableSection = inject(
  STATISTICS_VIEWER_STORE,
  STATISTICS_PAGE_STORE
)(
  observer(ViewersExpandableSectionComponent))
export { ViewersExpandableSection }
